import { IconProps } from './Close';

const Image = ({ size, backgroundColor, color }: IconProps) => {
  return (
    <svg
      id="img_icon"
      data-name="img icon"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size || '16'}
      height={size || '16'}
      viewBox="0 0 48 48"
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="사각형_2055"
            data-name="사각형 2055"
            width={size || '16'}
            height={size || '16'}
            transform="translate(-1717 13997)"
            fill={backgroundColor || '#fff'}
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <rect id="사각형_2054" data-name="사각형 2054" width="48" height="48" fill="none" />
      <g
        id="마스크_그룹_163"
        data-name="마스크 그룹 163"
        transform="translate(1718 -13996)"
        clipPath="url(#clip-path)"
      >
        <g id="Layer_2" data-name="Layer 2" transform="translate(-1717 13997)">
          <g id="Layer_2-2" data-name="Layer 2">
            <path
              id="패스_851"
              data-name="패스 851"
              d="M35.545,7H3.136A3.136,3.136,0,0,0,0,10.136V42.545a3.136,3.136,0,0,0,3.136,3.136H35.545a3.136,3.136,0,0,0,3.136-3.136V10.136A3.136,3.136,0,0,0,35.545,7Zm1.045,35.545a1.045,1.045,0,0,1-1.045,1.045H3.136a1.045,1.045,0,0,1-1.045-1.045V37.224L11.5,27.815,21.745,38.06a1.045,1.045,0,0,0,.732.3h0a1.045,1.045,0,0,0,.742-1.777l-2.4-2.4,6.367-6.367,9.409,9.409Zm0-8.27-7.935-7.935-1.474-1.474-1.474,1.474-6.367,6.367-6.367-6.367L11.5,24.867l-1.474,1.474L2.091,34.276V10.136A1.045,1.045,0,0,1,3.136,9.091H35.545a1.045,1.045,0,0,1,1.045,1.045Z"
              transform="translate(0 0.318)"
              fill={color || '#c4c4c4'}
            />
            <circle
              id="타원_420"
              data-name="타원 420"
              cx="4.182"
              cy="4.182"
              r="4.182"
              transform="translate(23 12.545)"
              fill={color || '#c4c4c4'}
            />
            <path
              id="패스_852"
              data-name="패스 852"
              d="M45.636,3.136V36.591a1.045,1.045,0,0,1-1.045,1.045h0a1.045,1.045,0,0,1-1.045-1.045V3.136A1.045,1.045,0,0,0,42.5,2.091H9.045A1.045,1.045,0,0,1,8,1.045H8A1.045,1.045,0,0,1,9.045,0H42.5a3.136,3.136,0,0,1,3.136,3.136Z"
              transform="translate(0.364)"
              fill={color || '#c4c4c4'}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Image;
